<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    荔湾站<br>
站点介绍<br>
荔湾站位于深圳市南山区港前路与前海路路口下方，主体呈西北至东南走向，西北接铁路公园站，东南接赤湾站。
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:27	00:19	5号线	3分钟	5分25秒<br>
黄贝岭	06:16	23:03	5号线	3分钟	5分25秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:29	00:18	5号线	4分钟	6分钟<br>
黄贝岭	06:21	23:03	5号线	4分钟	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:29	01:18	5号线	4分钟	6分钟<br>
黄贝岭	06:21	00:03	5号线	4分钟	6分钟<br><br>
<br>
站点出口信息<br>
A出入口:<br>
前海港湾花园、深大附中高中部、观峰阁、泛海拉菲花园二期、妈湾派出所、前海路西侧（南）、港前路南侧、德尚世家<br>
B出入口:<br>
泛海.拉菲花园、恒立心海湾花园、深大附中初中部、月亮湾公园、南山花园、前海路西侧（北）、港前路北侧（东）、青青世界<br>
C出入口:<br>
荔湾小学、月亮湾大道、港前路北侧（西）<br><br>
公交换乘信息<br>
A出入口:<br>
公交站名： 前海兴海路口<br>
M372、M364、M375、42、234、81、M347、M409、 M467、E3<br><br>
B出入口:<br>
公交站名： 南山花园<br>
M372、M364、M375、42、234、81、M347、M409、M467、E3<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "wuhaoxian",
          title: "5号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>


